// same check oe-rn-interactive-videos applies before it builds its bucket URL: `projectId/videoId`
const INTERACTIVE_VIDEO_ID = /^[A-Za-z0-9_-]+\/[A-Za-z0-9_-]+$/;

export function isInteractiveVideoId(mediaData: string): boolean {
  return !!mediaData && INTERACTIVE_VIDEO_ID.test(mediaData);
}



// WEBPACK FOOTER //
// ./ts/app/shared/helpers/is-interactive-video-id.ts